import { useCheckable } from './hooks/useCheckable';
import { useTabs } from './hooks/useTabs';
import { useStateForm } from './hooks/useStateForm';
import { useFixColorScheme } from './hooks/useFixColorScheme';

export const XSHooks = {
    useCheckable: useCheckable,
    useFixColorScheme: useFixColorScheme,
    useStateForm: useStateForm,
    useTabs: useTabs,
};
